import { atom } from 'jotai'

export const ssoLoadingState = atom(false)
